// import React from 'react';
// import { X, Loader2, Fingerprint, CheckIcon, AlertCircle } from 'lucide-react';

// const EnrollPopup = ({ 
//   isOpen, 
//   onClose, 
//   enrollment, 
//   selectedDevice, 
//   getEnrollmentStatusIcon, 
//   getEnrollmentStatusColor,
//   enrollmentStatus,
//   enrollmentMessage,
//   userToEnroll
// }) => {
//   if (!isOpen) return null;
//   console.log("Enrollment Message:",enrollmentStatus,enrollmentMessage)

//   const getStatusMessage = () => {
//     if (enrollmentStatus === 'error') {
//       return enrollment.message || enrollmentMessage || 'Enrollment failed. Please try again.';
//     }
//     if (enrollmentStatus === 'success') {
//       return 'Fingerprint has been enrolled successfully!';
//     }
//     if (enrollmentStatus === 'processing') {
//       return enrollmentMessage || 'Enrollment in progress. Please follow instructions on the device.';
//     }
//     return 'Ready to start enrollment. Please wait...';
//   };

//   const getTitle = () => {
//     if (enrollmentStatus === 'success') return 'Enrollment Complete!';
//     if (enrollmentStatus === 'error') return 'Enrollment Failed';
//     if (enrollmentStatus === 'processing') return 'Enrollment in Progress';
//     return 'Fingerprint Enrollment';
//   };

//   const getSubtitle = () => {
//     if (enrollmentStatus === 'success') {
//       return 'User has been successfully enrolled';
//     }
//     if (enrollmentStatus === 'error') {
//       return 'There was an error during enrollment';
//     }
//     if (enrollmentStatus === 'processing') {
//       return 'Please follow the device instructions';
//     }
//     return 'Starting enrollment process...';
//   };

//   return (
//     <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
//       <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
//       <div className="relative w-full max-w-md p-6 mx-4 border shadow-2xl bg-gradient-to-br from-blue-900 to-blue-950 rounded-2xl"
//         style={{ 
//           borderColor: enrollmentStatus === 'success' ? '#22c55e' : 
//                       enrollmentStatus === 'error' ? '#ef4444' : 
//                       '#3b82f6' 
//         }}>
        
//         <button 
//           onClick={onClose} 
//           className="absolute text-blue-300 top-4 right-4 hover:text-white"
//         >
//           <X className="w-6 h-6" />
//         </button>

//         <div className="text-center">
//           {/* Header */}
//           <div className="mb-6">
//             <h2 className="text-xl font-bold text-white">{getTitle()}</h2>
//             <p className="text-sm text-blue-300">{getSubtitle()}</p>
//           </div>

//           {/* Device Info */}
//           {selectedDevice && (
//             <div className="p-3 mb-6 text-sm border rounded-lg bg-white/5 border-blue-500/20">
//               <div className="flex justify-between">
//                 <span className="text-blue-300">Device:</span>
//                 <span className="text-white">{selectedDevice.device_name}</span>
//               </div>
//               <div className="flex justify-between mt-1">
//                 <span className="text-blue-300">Status:</span>
//                 <span className="text-green-400">{selectedDevice.last_status}</span>
//               </div>
//               {userToEnroll && (
//                 <div className="flex justify-between mt-1">
//                   <span className="text-blue-300">User:</span>
//                   <span className="text-white">{userToEnroll.user_name} ({userToEnroll.user_roll})</span>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Status Icon and Message */}
//           <div className="mb-6">
//             <div className="flex justify-center mb-4">
//               <div className="relative">
//                 {(enrollmentStatus === 'processing') && (
//                   <>
//                     <div className="absolute inset-0 rounded-full bg-blue-500/20 animate-ping" />
//                     <div className="absolute inset-0 rounded-full bg-blue-500/30 animate-pulse" />
//                   </>
//                 )}
//                 <div className={`relative flex items-center justify-center w-24 h-24 rounded-full ${
//                   enrollmentStatus === 'success' ? 'bg-gradient-to-br from-green-600 to-emerald-600' :
//                   enrollmentStatus === 'error' ? 'bg-gradient-to-br from-red-600 to-rose-600' :
//                   'bg-gradient-to-br from-blue-600 to-cyan-600'
//                 }`}>
//                   {getEnrollmentStatusIcon()}
//                 </div>
//               </div>
//             </div>

//             <h3 className={`text-lg font-semibold mb-2 ${
//               enrollmentStatus === 'success' ? 'text-green-400' :
//               enrollmentStatus === 'error' ? 'text-red-400' :
//               'text-blue-400'
//             }`}>
//               {getStatusMessage()}
//             </h3>

//             {enrollmentStatus === 'processing' && (
//               <div className="p-3 mt-4 border rounded-lg bg-blue-900/30 border-blue-700/50">
//                 <p className="text-sm text-blue-300">
//                   💡 Please place your finger on the device sensor when prompted
//                 </p>
//                 <p className="mt-2 text-xs text-blue-400">
//                   The device will guide you through the enrollment process
//                 </p>
//               </div>
//             )}

//             {enrollmentStatus === 'error' && (
//               <div className="p-3 mt-4 border rounded-lg bg-red-900/30 border-red-700/50">
//                 <p className="text-sm text-red-300">
//                   Troubleshooting tips:
//                 </p>
//                 <ul className="mt-1 text-xs list-disc list-inside text-red-200/80">
//                   <li>Make sure the device is still connected and online</li>
//                   <li>Check if the user hasn't been enrolled before</li>
//                   <li>Ensure the fingerprint is clean and placed correctly</li>
//                   <li>Try again or contact support</li>
//                 </ul>
//               </div>
//             )}

//             {enrollmentStatus === 'success' && (
//               <div className="p-3 mt-4 border rounded-lg bg-green-900/30 border-green-700/50">
//                 <p className="text-sm text-green-300">
//                   ✓ The user can now use their fingerprint to access the device
//                 </p>
//               </div>
//             )}
//           </div>

//           {/* Close/Cancel Button */}
//           {(enrollmentStatus === 'error' || enrollmentStatus === 'success') && (
//             <button
//               onClick={onClose}
//               className={`w-full px-6 py-2 font-semibold text-white transition-all rounded-lg ${
//                 enrollmentStatus === 'success' ? 'bg-green-600 hover:bg-green-500' : 'bg-red-600 hover:bg-red-500'
//               }`}
//             >
//               {enrollmentStatus === 'success' ? 'Close' : 'Try Again'}
//             </button>
//           )}

//           {enrollmentStatus === 'processing' && (
//             <button
//               onClick={onClose}
//               className="w-full px-6 py-2 font-semibold text-white transition-all bg-gray-600 rounded-lg hover:bg-gray-500"
//             >
//               Cancel
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EnrollPopup;



import React from 'react';
import { X } from 'lucide-react';

const EnrollPopup = ({ 
  isOpen, 
  onClose, 
  enrollment, 
  selectedDevice, 
  getEnrollmentStatusIcon, 
  getEnrollmentStatusColor,
  enrollmentStatus,
  enrollmentMessage,
  userToEnroll,
  theme
}) => {
  if (!isOpen) return null;
  console.log("Enrollment Message:",enrollmentStatus,enrollmentMessage)

  const isDark = theme === 'dark';

  // Theme-aware classes
  const bgOverlay = isDark ? 'bg-black/70' : 'bg-gray-500/40';
  const bgPopup = isDark 
    ? 'bg-gradient-to-br from-blue-900 to-blue-950' 
    : 'bg-gradient-to-br from-blue-100 to-gray-100';
  const bgDeviceInfo = isDark ? 'bg-white/5 border-blue-500/20' : 'bg-white/40 border-blue-300/50';
  const bgStatusBox = isDark ? 'bg-blue-900/30 border-blue-700/50' : 'bg-blue-100/50 border-blue-300';
  const bgErrorBox = isDark ? 'bg-red-900/30 border-red-700/50' : 'bg-red-100/50 border-red-300';
  const bgSuccessBox = isDark ? 'bg-green-900/30 border-green-700/50' : 'bg-green-100/50 border-green-300';
  
  //const borderColor = isDark ? 'border-blue-700' : 'border-blue-300';
  //const borderSuccess = isDark ? 'border-green-500' : 'border-green-400';
  //const borderError = isDark ? 'border-red-500' : 'border-red-400';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  const textSecondary = isDark ? 'text-blue-300' : 'text-gray-700';
  //const textMuted = isDark ? 'text-blue-300' : 'text-gray-600';
  const textSuccess = isDark ? 'text-green-400' : 'text-green-600';
  const textError = isDark ? 'text-red-400' : 'text-red-600';
  const textBlue = isDark ? 'text-blue-400' : 'text-blue-600';
  
  const buttonClose = isDark 
    ? 'text-blue-300 hover:text-white' 
    : 'text-gray-500 hover:text-gray-900';
  const buttonSuccess = isDark ? 'bg-green-600 hover:bg-green-500' : 'bg-green-500 hover:bg-green-600';
  const buttonError = isDark ? 'bg-red-600 hover:bg-red-500' : 'bg-red-500 hover:bg-red-600';
  const buttonCancel = isDark ? 'bg-gray-600 hover:bg-gray-500' : 'bg-gray-400 hover:bg-gray-500';

  const getStatusMessage = () => {
    if (enrollmentStatus === 'error') {
      return enrollment.message || enrollmentMessage || 'Enrollment failed. Please try again.';
    }
    if (enrollmentStatus === 'success') {
      return 'Fingerprint has been enrolled successfully!';
    }
    if (enrollmentStatus === 'processing') {
      return enrollmentMessage || 'Enrollment in progress. Please follow instructions on the device.';
    }
    return 'Ready to start enrollment. Please wait...';
  };

  const getTitle = () => {
    if (enrollmentStatus === 'success') return 'Enrollment Complete!';
    if (enrollmentStatus === 'error') return 'Enrollment Failed';
    if (enrollmentStatus === 'processing') return 'Enrollment in Progress';
    return 'Fingerprint Enrollment';
  };

  const getSubtitle = () => {
    if (enrollmentStatus === 'success') {
      return 'User has been successfully enrolled';
    }
    if (enrollmentStatus === 'error') {
      return 'There was an error during enrollment';
    }
    if (enrollmentStatus === 'processing') {
      return 'Please follow the device instructions';
    }
    return 'Starting enrollment process...';
  };

  return (
    <div className={`fixed inset-0 z-[60] flex items-center justify-center p-4`}>
      <div className={`absolute inset-0 ${bgOverlay} backdrop-blur-sm`} onClick={onClose} />
      <div className={`relative w-full max-w-md p-6 mx-4 border shadow-2xl ${bgPopup} rounded-2xl transition-colors duration-300`}
        style={{ 
          borderColor: enrollmentStatus === 'success' ? '#22c55e' : 
                      enrollmentStatus === 'error' ? '#ef4444' : 
                      (isDark ? '#3b82f6' : '#93c5fd')
        }}
      >
        
        <button 
          onClick={onClose} 
          className={`absolute top-4 right-4 ${buttonClose} transition-colors`}
        >
          <X className="w-6 h-6" />
        </button>

        <div className="text-center">
          {/* Header */}
          <div className="mb-6">
            <h2 className={`text-xl font-bold ${textPrimary}`}>{getTitle()}</h2>
            <p className={`text-sm ${textSecondary}`}>{getSubtitle()}</p>
          </div>

          {/* Device Info */}
          {selectedDevice && (
            <div className={`p-3 mb-6 text-sm border rounded-lg ${bgDeviceInfo} transition-colors duration-300`}>
              <div className="flex justify-between">
                <span className={isDark ? 'text-blue-300' : 'text-gray-600'}>Device:</span>
                <span className={textPrimary}>{selectedDevice.device_name}</span>
              </div>
              <div className="flex justify-between mt-1">
                <span className={isDark ? 'text-blue-300' : 'text-gray-600'}>Status:</span>
                <span className="text-green-400">{selectedDevice.last_status}</span>
              </div>
              {userToEnroll && (
                <div className="flex justify-between mt-1">
                  <span className={isDark ? 'text-blue-300' : 'text-gray-600'}>User:</span>
                  <span className={textPrimary}>{userToEnroll.user_name} ({userToEnroll.user_roll})</span>
                </div>
              )}
            </div>
          )}

          {/* Status Icon and Message */}
          <div className="mb-6">
            <div className="flex justify-center mb-4">
              <div className="relative">
                {(enrollmentStatus === 'processing') && (
                  <>
                    <div className="absolute inset-0 rounded-full bg-blue-500/20 animate-ping" />
                    <div className="absolute inset-0 rounded-full bg-blue-500/30 animate-pulse" />
                  </>
                )}
                <div className={`relative flex items-center justify-center w-24 h-24 rounded-full ${
                  enrollmentStatus === 'success' ? 'bg-gradient-to-br from-green-600 to-emerald-600' :
                  enrollmentStatus === 'error' ? 'bg-gradient-to-br from-red-600 to-rose-600' :
                  'bg-gradient-to-br from-blue-600 to-cyan-600'
                }`}>
                  {getEnrollmentStatusIcon()}
                </div>
              </div>
            </div>

            <h3 className={`text-lg font-semibold mb-2 ${
              enrollmentStatus === 'success' ? textSuccess :
              enrollmentStatus === 'error' ? textError :
              textBlue
            }`}>
              {getStatusMessage()}
            </h3>

            {enrollmentStatus === 'processing' && (
              <div className={`mt-4 p-3 border rounded-lg ${bgStatusBox} transition-colors duration-300`}>
                <p className={`text-sm ${textSecondary}`}>
                  💡 Please place your finger on the device sensor when prompted
                </p>
                <p className={`mt-2 text-xs ${isDark ? 'text-blue-400' : 'text-gray-500'}`}>
                  The device will guide you through the enrollment process
                </p>
              </div>
            )}

            {enrollmentStatus === 'error' && (
              <div className={`mt-4 p-3 border rounded-lg ${bgErrorBox} transition-colors duration-300`}>
                <p className={`text-sm ${textError}`}>
                  Troubleshooting tips:
                </p>
                <ul className={`mt-1 text-xs ${isDark ? 'text-red-200/80' : 'text-red-700'} list-disc list-inside`}>
                  <li>Make sure the device is still connected and online</li>
                  <li>Check if the user hasn't been enrolled before</li>
                  <li>Ensure the fingerprint is clean and placed correctly</li>
                  <li>Try again or contact support</li>
                </ul>
              </div>
            )}

            {enrollmentStatus === 'success' && (
              <div className={`mt-4 p-3 border rounded-lg ${bgSuccessBox} transition-colors duration-300`}>
                <p className={`text-sm ${textSuccess}`}>
                  ✓ The user can now use their fingerprint to access the device
                </p>
              </div>
            )}
          </div>

          {/* Close/Cancel Button */}
          {(enrollmentStatus === 'error' || enrollmentStatus === 'success') && (
            <button
              onClick={onClose}
              className={`w-full px-6 py-2 font-semibold text-white transition-all rounded-lg ${
                enrollmentStatus === 'success' ? buttonSuccess : buttonError
              }`}
            >
              {enrollmentStatus === 'success' ? 'Close' : 'Try Again'}
            </button>
          )}

          {enrollmentStatus === 'processing' && (
            <button
              onClick={onClose}
              className={`w-full px-6 py-2 font-semibold text-white transition-all rounded-lg ${buttonCancel}`}
            >
              Cancel
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EnrollPopup;
